import { CreditCard, DownloadSimple, Key, Play, QrCode } from "@phosphor-icons/react";

const STEPS = [
  { Icon: DownloadSimple, title: "Instalirajte aplikaciju", text: "Preuzmite BalkanHD Play na svoj TV, telefon ili tablet iz prodavnice aplikacija i otvorite je." },
  { Icon: Key, title: "Pronađite svoj kod", text: "U aplikaciji otvorite Podešavanja → „Aktiviraj / Obnovi”. Na ekranu piše vaš Device Key (npr. 2XJW9V), MAC adresa i QR kod." },
  { Icon: QrCode, title: "Skenirajte QR kod", text: "Kamerom telefona skenirajte QR kod sa ekrana. Otvoriće se ova stranica sa već upisanim podacima. Ili ih upišite ručno." },
  { Icon: CreditCard, title: "Izaberite paket i platite", text: "Kliknite „Proveri uređaj”, izaberite godišnji ili doživotni paket i platite karticom. Plaćanje je bezbedno (Stripe)." },
  { Icon: Play, title: "Gotovo — uživajte", text: "Uređaj se aktivira automatski za par sekundi. Ako ne vidite promenu, zatvorite i ponovo otvorite aplikaciju." },
];

export const ActivationSteps = ({ compact }) => (
  <div className="flex w-full flex-col gap-3">
    {STEPS.map(({ Icon, title, text }, i) => (
      <div key={title} data-testid={`activation-step-${i + 1}`}
        className={`flex border border-line bg-surface2 ${compact ? "gap-3 rounded-xl p-3" : "gap-4 rounded-[20px] p-4"}`}>
        <div className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-brand text-lg font-bold text-white">{i + 1}</div>
        <div className="flex flex-1 flex-col gap-1">
          <div className="flex items-center gap-2">
            <Icon size={18} weight="fill" className="text-brand" />
            <span className="text-base font-bold">{title}</span>
          </div>
          <p className="text-sm leading-[21px] text-txt2">{text}</p>
        </div>
      </div>
    ))}
  </div>
);
